import type { HelpFile } from '../../types/help'
import { NotificationDetailTestIds } from '../../../testids/NotificationDetailTestIds'

export const notificationDetailHelp: HelpFile = {
  docPage: '/docs/my-iam/notifications',
  texts: {
    [NotificationDetailTestIds.notificationDetailPage]:
      'Vollständiger Inhalt und Kontext einer Benachrichtigung — Ereignis, Zeitstempel, Schweregrad und verknüpfte Entität.',
    [NotificationDetailTestIds.cardNotificationDetail]:
      'Metadaten der Benachrichtigung: Betreff, Zeitstempel, Schweregrad und Zustellungskanal.',
    [NotificationDetailTestIds.notificationMessage]: null,
    [NotificationDetailTestIds.cardTitleGoToReference]:
      'Direkter Link zur Entität, auf die sich diese Benachrichtigung bezieht.',
    [NotificationDetailTestIds.linkReferencedEntity]: null,
  },
}
